import React from 'react';
import PropTypes, { any } from 'prop-types';
import { useHistory } from 'react-router-dom';

import styles from './nextAvailableLiveMatches.scss';
import AvatarV2 from '../../../../../components/cards/PlayerCard/ListViewComponents/AvatarV2';
import { divisionFormatTypeIds, sportTypeIds, utrTypeIds } from '../../../../../utils/eventConstants';
import { gameTypes } from '../../../../../utils/constants';
import { Utr } from '../../../../../components/text';

const Player = (props) => {
    const {
        player,
        sportTypeId,
        utrTypeId,
        formatTypeId,
    } = props;

    const history = useHistory();

    const gameType = formatTypeId === divisionFormatTypeIds.SINGLES ? gameTypes.SINGLES : gameTypes.DOUBLES;
    const nameToDisplay = [
        player.firstName,
        player.lastName,
    ].filter((s) => s?.length > 0).join(' ');

    const onPlayerClick = () => {
        history.push(`/profiles/${player.playerId}`);
    };

    return (
        <div
            className={styles.player}
            onClick={onPlayerClick}
        >
            <AvatarV2 playerImages={player.playerProfileImages} nationality={player.nationality} player={player} />
            <div className="name-and-place">
                {nameToDisplay}
                <span>
                    <Utr
                        player={player}
                        force={{ ratingType: gameType, utrType: utrTypeId, verifiedIcon: true, showDecimals: false }}
                        sportTypeId={sportTypeId}
                    />
                </span>
            </div>
        </div>
    );
};

Player.propTypes = {
    player: PropTypes.objectOf(any).isRequired,
    utrTypeId: PropTypes.number,
    sportTypeId: PropTypes.number,
    formatTypeId: PropTypes.number,
};

Player.defaultProps = {
    utrTypeId: utrTypeIds.MYUTR,
    sportTypeId: sportTypeIds.TENNIS,
    formatTypeId: divisionFormatTypeIds.SINGLES,
};

export default Player;
